export default __webpack_public_path__ + "static/media/done.65461516.png";